import { getCurrentUser } from 'data/auth/selectors'
import { RootState } from 'duck/store'
import { connect } from 'react-redux'

import UserHeader, { UserHeaderProps } from './presentational'

function mapStateToProps(state: RootState): StateProps {
  const currentUser = getCurrentUser(state)

  let userFirstName, userLastName, userGroupName, userProfilePictureUrl
  if (currentUser) {
    userFirstName = currentUser.firstName
    userLastName = currentUser.lastName
    userProfilePictureUrl = undefined
    userGroupName = undefined

    // const userGroup = currentUser.userGroupId ? getUserGroup(state, currentUser.userGroupId) : undefined
    // userGroupName = userGroup ? userGroup.name : undefined
  }

  return {
    userFirstName,
    userLastName,
    userGroupName,
    userProfilePictureUrl,
  }
}

type StateProps = Pick<UserHeaderProps, 'userFirstName' | 'userLastName' | 'userGroupName' | 'userProfilePictureUrl'>

export default connect(mapStateToProps)(UserHeader)
